/**
 * entityKey -> REST path.
 *
 * The third of the three things `createCrudPages` needs (columns, schema, entity key).
 * Keeping the mapping here rather than in each feature means a path change is one edit,
 * and `useListQuery('employees')` reads the same everywhere.
 */
export const ENDPOINTS = {
  // admin
  users: '/v1/admin/users',
  roles: '/v1/admin/roles',
  permissions: '/v1/admin/permissions',
  auditLogs: '/v1/admin/audit-logs',
  loginHistory: '/v1/admin/login-history',
  apiKeys: '/v1/admin/api-keys',
  featureFlags: '/v1/admin/feature-flags',

  // organisation
  legalEntities: '/v1/org/legal-entities',
  departments: '/v1/org/departments',
  designations: '/v1/org/designations',
  grades: '/v1/org/grades',
  locations: '/v1/org/locations',
  positions: '/v1/org/positions',
  costCenters: '/v1/org/cost-centers',

  // people
  employees: '/v1/employees',

  // workflow
  workflowDefinitions: '/v1/workflow/definitions',
  workflowInbox: '/v1/workflow/inbox',

  // cross-cutting
  notifications: '/v1/notifications',
  files: '/v1/files',
  search: '/v1/search',
  dashboard: '/v1/dashboard',
  settings: '/v1/settings',
} as const

export type EntityKey = keyof typeof ENDPOINTS

export function endpointFor(entityKey: EntityKey): string {
  return ENDPOINTS[entityKey]
}
